import { Typography } from '@design-system/atoms/typography/Typography';
import styled from '@emotion/styled';

export const Underlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
`;

export const ModalWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.technical.white};
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 80%;
  max-height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: modalFadeIn 0.2s ease-out;

  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ModalHeader = styled.div<{ $withSubtitle?: boolean }>`
  display: flex;
  align-items: ${({ $withSubtitle }) => ($withSubtitle ? 'flex-start' : 'center')};
  justify-content: space-between;
  gap: 16px;
  padding: ${({ $withSubtitle }) => ($withSubtitle ? '24px 24px 0' : '16px 24px')};
`;

export const ModalHeaderMain = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  flex: 1;
  min-width: 0;
`;

export const ModalTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.technical.adaptive};
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  color: ${({ theme }) => theme.colors.technical.gray[60]};
  border-radius: 4px;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.technical.gray[15]};
    color: ${({ theme }) => theme.colors.technical.gray[60]};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary.medium};
    outline-offset: 1px;
  }
`;

export const ModalContent = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
`;
